<template>
	<div class="section">
		<div class="container">
			<h1 class="mb-4">CTC Compliance Index by country</h1>
			<div id="countryMap">
				<div class="map-legend">
					<div class="legend">
						<div>Compliance:</div>
						<div class="vhigh">Very High</div>
						<div class="high">High</div>
						<div class="medium">Medium</div>
						<div class="low">Low</div>
						<div class="suspended">Suspended</div>
						<div class="insufficient">Insufficient Legal Analysis</div>
						<div class="nodata">No data available</div>
					</div>
					<div class="legend">
						<div>Watchlist:</div>
						<div class="vhigh-watchlist">Very High</div>
						<div class="high-watchlist">High</div>
						<div class="medium-watchlist">Medium</div>
						<div class="low-watchlist">Low</div>
					</div>
					<div class="description"></div>
				</div>
				<div class="has-text-centered" v-show="!loading && !initialized">
					A problem occurred loading the map.
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import svgMap from "svgmap/dist/svgMap.min.js";
	import "svgmap/dist/svgMap.min.css";
	import mapDefs from "@/components/user/complianceIndex/mapDefs";

	const cc = svgMap.prototype.countries || {};

	export default {
		data() {
			return {
				loading: true,
				initialized: false,
				groups: []
			};
		},
		computed: {
			isFrameElement() {
				return window.frameElement ? true : false;
			}
		},
		methods: {
			async GetComplianceIndexList() {
				try {
					var response = await this.$http.get("api/group/index/list");
					this.groups = response.data;
				} catch (err) {
					console.error(err);
				}
			},
			CheckName(groupName, countryName) {
				if (countryName == "Niger") {
					return groupName == countryName;
				}
				else {
					return groupName.includes(countryName);
				}
			},
			CreateMap() {
				// Match against Group and the internal country codes for svgMap.
				// Color shading happens with respect to Score.
				// Anything that fails to match does not get added to the map.  TODO: It'd be best to update the database with the matching country codes to explicitly match each key.
				let countries = {};
				//console.log({ lookup: cc, groups: this.groups, check: this.groups.filter(x => x.Group.includes("Niger")) });
				for (const prop in cc) {
					const countryName = cc[prop];
					const match = this.groups.find((x) => this.CheckName(x.Group, countryName));
					if (match) {
						let color = undefined;
						color = this.GetColor(match);
						//if (match.Watchlist) color = "#fcc208";
						//if (match.Suspended) color = "#cd5c5c";

						countries[prop] = {
							group: match.Group,
							score: match.Score,
							asu: match.Suspended ? "Suspended" : match.ASU,
							category: match.Category,
							pba: match.PBA,
							watchlist: match.Watchlist ? "Yes" : "No",
							link: "/index/" + match.GroupId,
							color: color
						};
					}
				}

				new svgMap({
					targetElementID: "countryMap",
					colorMax: "#4c45ff",
					colorMin: "#d9e8ff",
					mouseWheelZoomEnabled: false,
					data: {
						data: {
							group: {
								name: "Country",
								format: "{0}"
							},
							score: {
								name: "Score",
								format: "{0}",
								thresholdMax: 100
							},
							asu: {
								name: "ASU Eligible",
								format: "{0}"
							},
							category: {
								name: "Category",
								format: "{0}"
							},
							watchlist: {
								name: "Watchlist",
								format: "{0}"
							}
						},
						applyData: "score",
						values: {
							...countries
						}
					}
				});
			},
			GetColor(row) {
				if (row.Suspended) return "#b4b4b4"; //"#cbcbcb";
				if (row.ASU == "Insufficient legal analysis") return "#d9e8ff";

				let vector = [0, 0, 0, 0]; //Adds vector to rgba to apply some scaling factor against shading.

				switch (row.Category) {
					case "Very High": {
						let rgba = [226, 241, 216, 1];

						if (row.Watchlist) {
							return "url('#crosshatch-vhigh')";
						}

						rgba = this.AddColors(rgba, vector);
						return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
						//return "rgba(226, 241, 216, 0.99)";
					}
					case "High": {
						let rgba = [253, 243, 202, 1];

						if (row.Watchlist) {
							return "url('#crosshatch-high')";
						}

						rgba = this.AddColors(rgba, vector);
						return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
						//return "rgba(253, 243, 202, 0.99)";
					}
					case "Medium": {
						let rgba = [248, 230, 213, 1];

						if (row.Watchlist) {
							return "url('#crosshatch-medium')";
						}

						rgba = this.AddColors(rgba, vector);
						return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
						//return "rgba(248, 230, 213, 0.99)";
					}
					case "Low": {
						if (row.Score > 0) {
							let rgba = [250, 205, 204, 1];

							if (row.Watchlist) {
								return "url('#crosshatch-low')";
							}

							rgba = this.AddColors(rgba, vector);
							return `rgba(${rgba[0]}, ${rgba[1]}, ${rgba[2]}, ${rgba[3]})`;
							//return "rgba(250, 205, 204, 0.99)";
						} else {
							return "#d9ecff";
						}
					}
				}
			},
			AddColors(v1, v2) {
				const v = [0, 0, 0, 0];
				v[0] += v1[0] + v2[0];
				v[1] += v1[1] + v2[1];
				v[2] += v1[2] + v2[2];
				v[3] += v1[3] + v2[3];

				v[0] = v[0] > 255 ? 255 : v[0];
				v[1] = v[1] > 255 ? 255 : v[1];
				v[2] = v[2] > 255 ? 255 : v[2];
				v[3] = v[3] > 1 ? 1 : v[3];
				return v;
			},
			AddSvgDefinitions() {
				mapDefs.vhigh();
				mapDefs.high();
				mapDefs.medium();
				mapDefs.low();
			}
		},
		async mounted() {
			this.loading = true;
			await this.GetComplianceIndexList();
			if (this.groups.length > 0) {
				this.CreateMap();
				this.initialized = true;
			}
			this.loading = false;

			this.AddSvgDefinitions();
		}
	};
</script>
<style lang="scss">
	.svgMap-map-wrapper {
		background: #fefefe;
	}

	.map-legend {
		text-align: center;
		& > .legend {
			display: flex;
			flex-flow: row wrap;
			// justify-content: center;
			cursor: default;
			& > div {
				position: relative;
				margin-left: 24px;
				margin-right: 10px;
				&::before {
					content: "";
					display: block;
					position: absolute;
					width: 20px;
					height: 20px;
					border-radius: 1px;
					top: 22%;
					left: -24px;
				}

				&.vhigh::before {
					background-color: rgba(226, 241, 216, 1);
					border: solid 1px #cbcbcb;
				}
				&.high::before {
					background-color: rgba(253, 243, 202, 1);
					border: solid 1px #cbcbcb;
				}
				&.medium::before {
					background-color: rgba(248, 230, 213, 1);
					border: solid 1px #cbcbcb;
				}
				&.low::before {
					background-color: rgba(250, 205, 204, 1);
					border: solid 1px #cbcbcb;
				}
				&.insufficient::before {
					background-color: #d9e8ff;
					border: solid 1px #cbcbcb;
				}
				&.suspended::before {
					background-color: #b4b4b4;
					border: solid 1px #cbcbcb;
				}
				&.nodata::before {
					background-color: #e2e2e2;
					border: solid 1px #cbcbcb;
				}

				&.vhigh-watchlist::before {
					background-color: rgba(226, 241, 216, 1);
					background-image: repeating-linear-gradient(
						-45deg,
						transparent 0,
						transparent 4px,
						black 4px,
						black 5px
					);
					border: solid 1px #cbcbcb;
				}
				&.high-watchlist::before {
					background-color: rgba(253, 243, 202, 1);
					background-image: repeating-linear-gradient(
						-45deg,
						transparent 0,
						transparent 4px,
						black 4px,
						black 5px
					);
					border: solid 1px #cbcbcb;
				}
				&.medium-watchlist::before {
					background-color: rgba(248, 230, 213, 1);
					background-image: repeating-linear-gradient(
						-45deg,
						transparent 0,
						transparent 4px,
						black 4px,
						black 5px
					);
					border: solid 1px #cbcbcb;
				}
				&.low-watchlist::before {
					background-color: rgba(250, 205, 204, 1);
					background-image: repeating-linear-gradient(
						-45deg,
						transparent 0,
						transparent 4px,
						black 4px,
						black 5px
					);
					border: solid 1px #cbcbcb;
				}
			}
		}
	}
</style>
